// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"468dc0d0","256":"e46ef75c","342":"ea380626","365":"f62dcecf","394":"53d45aca","912":"c54a8ae1"}[chunkId] + ".chunk.css";
};